<ion-grid class="team">
    <ion-row class="header">
        <ion-col size="3"></ion-col>
        <ion-col size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="useTranslationOnOverallEvaluation; else usePossibleValues">
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValuesGlobalized[selectedLanguage]; let ratingIndex = index">
                            {{ rating }}
                        </ion-col>
                    </ng-container>
                    <ng-template #usePossibleValues>
                        <ion-col *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" centered>
                            {{ rating }}
                        </ion-col>
                    </ng-template>
                    <ion-col colored highlight>
                        TOTAL
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="body">
        <ion-col size="3">
            <ion-grid>
                <ion-row>
                    <ion-col highlight>
                        360º
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else threeSixtyWithTooltip">
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" [matTooltip]="participant?.evaluators?.threeSixtyEvaluators[rating]">
                            {{ participant?.ratings?.threeSixtyRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored [matTooltip]="getAllEvaluators(participant?.evaluators?.threeSixtyEvaluators)">
                            {{ getTotalEvaluators(participant?.ratings?.threeSixtyRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #threeSixtyWithTooltip>
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues">
                            {{ participant?.ratings?.threeSixtyRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored>
                            {{ getTotalEvaluators(participant?.ratings?.threeSixtyRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="body" *ngIf="participant?.user?.isManager">
        <ion-col size="3">
            <ion-grid>
                <ion-row>
                    <ion-col highlight>
                        {{ 'generic.employees' | translate }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipDR">
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" [matTooltip]="participant?.evaluators?.directReportEvaluators[rating]">
                            {{ participant?.ratings?.directReportRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored [matTooltip]="getAllEvaluators(participant?.evaluators?.directReportEvaluators)">
                            {{ getTotalEvaluators(participant?.ratings?.directReportRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipDR>
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues">
                            {{ participant?.ratings?.directReportRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored>
                            {{ getTotalEvaluators(participant?.ratings?.directReportRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="body">
        <ion-col size="3">
            <ion-grid>
                <ion-row>
                    <ion-col highlight>
                        {{ 'dashboard.freeEvaluation' | translate }}
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipFreeEvaluators">
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" [matTooltip]="participant?.evaluators?.freeEvaluators ? participant?.evaluators?.freeEvaluators[rating] : ''">
                            {{ participant?.ratings?.freeEvaluationRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored [matTooltip]="getAllEvaluators(participant?.evaluators?.freeEvaluators)">
                            {{ getTotalEvaluators(participant?.ratings?.freeEvaluationRatings) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipFreeEvaluators>
                        <ion-col centered *ngFor="let rating of participant?.ratings?.ratingsPossibleValues">
                            {{ participant?.ratings?.freeEvaluationRatings[rating] }}
                        </ion-col>
                        <ion-col centered highlight colored>
                            {{ getTotalEvaluators(participant?.ratings?.freeEvaluationRatings) }}
                        </ion-col>
                    </ng-template>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>

    <ion-row class="body">
        <ion-col size="3">
            <ion-grid>
                <ion-row>
                    <ion-col colored highlight>
                        TOTAL
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="9">
            <ion-grid>
                <ion-row>
                    <ng-container *ngIf="showTooltips; else withTooltipRatingTotals">
                        <ion-col *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" centered colored highlight [matTooltip]="getRatingTotalEvaluators(rating)">
                            {{ getRatingTotals(rating) }}
                        </ion-col>
                    </ng-container>
                    <ng-template #withTooltipRatingTotals>
                        <ion-col *ngFor="let rating of participant?.ratings?.ratingsPossibleValues" centered colored highlight>
                            {{ getRatingTotals(rating) }}
                        </ion-col>
                    </ng-template>
                    <ion-col></ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="header"
             [ngClass]="{ 'small-text-size': anyCalculated}">
        <ion-col size="2"></ion-col>
        <ion-col size="10">
            <ion-grid>
                <ion-row>
                    <ion-col *ngIf="goalsCalculated">
                        {{ 'calibration.qtdQuestionsUsedForCalculate' | translate }}
                    </ion-col>
                    <ion-col>
                        <ion-label>Goals</ion-label>
                    </ion-col>
                    <ion-col *ngIf="principleCalculated">
                        {{ 'calibration.qtdQuestionsUsedForCalculate' | translate }}
                    </ion-col>
                    <ion-col>
                        <ion-label>Principles</ion-label>
                    </ion-col>
                    <ion-col *ngIf="showLeadershipValues">
                        Leadership
                    </ion-col>
                    <ion-col *ngIf="finalCalculated">
                        {{ 'calibration.qtdQuestionsUsedForCalculate' | translate }}
                    </ion-col>
                    <ion-col>
                        <ion-label>Final</ion-label>
                    </ion-col>
                    <ion-col colored *ngIf="canEditManagerEvaluation">
                        <ion-label>Edit</ion-label>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="body"
             [ngClass]="{ 'small-text-size': anyCalculated}">
        <ion-col size="2">
            <ion-grid>
                <ion-row>
                    <ion-col highlight>
                        SELF
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="10">
            <ion-grid class="self-manager-evaluation">
                <ion-row>
                    <ion-col *ngIf="goalsCalculated">
                        {{ participant?.selfEvaluation?.finalGoalsSelfEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <ion-col *ngIf="goalsCalculated">
                        {{ participant?.selfEvaluation?.finalGoalsSelfEvaluationFormula }}
                    </ion-col>
                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalGoalsSelf">
                            {{ participant?.selfEvaluation?.finalGoalsSelfEvaluationTranslated }}
                        </ng-container>
                        <ng-template #useFinalGoalsSelf>
                            {{ participant?.selfEvaluation?.finalGoalsSelfEvaluation | translate }}
                        </ng-template>
                    </ion-col>
                    <ion-col *ngIf="principleCalculated">
                        {{ participant?.selfEvaluation?.finalPrinciplesSelfEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <!--                    <ion-col *ngIf="principleCalculated">-->
                    <!--                        {{ user.finalPrinciplesSelfEvaluationFormula }}-->
                    <!--                    </ion-col>-->

                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalPrinciplesSelf">
                            {{ participant?.selfEvaluation?.finalPrinciplesSelfEvaluationTranslated | translate }}
                        </ng-container>
                        <ng-template #useFinalPrinciplesSelf>
                            {{ participant?.selfEvaluation?.finalPrinciplesSelfEvaluation | translate }}
                        </ng-template>
                    </ion-col>

                    <ion-col *ngIf="showLeadershipValues">
                        {{ ( participant?.selfEvaluation?.finalLeadershipSelfEvaluationTranslated | translate) || '--' }}
                    </ion-col>
                    
                    <ion-col *ngIf="finalCalculated">
                        {{ participant?.selfEvaluation?.finalSelfEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <!--                    <ion-col *ngIf="finalCalculated">-->
                    <!--                        {{ user.finalSelfEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalSelf">
                            {{ participant?.selfEvaluation?.finalSelfEvaluationTranslated | translate }}
                        </ng-container>
                        <ng-template #useFinalSelf>
                            {{ participant?.selfEvaluation?.finalSelfEvaluation | translate }}
                        </ng-template>
                    </ion-col>
                    <ion-col></ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
    <ion-row class="body"
             [ngClass]="{ 'small-text-size': anyCalculated}">
        <ion-col size="2">
            <ion-grid>
                <ion-row>
                    <ion-col highlight>
                        MANAGER
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
        <ion-col size="10">
            <ion-grid class="self-manager-evaluation">
                <ion-row>
                    <ion-col *ngIf="goalsCalculated">
                        {{ participant?.managerEvaluation?.finalGoalsManagerEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <!--                    <ion-col *ngIf="goalsCalculated">-->
                    <!--                        {{ participant?.managerEvaluation?.finalGoalsManagerEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalGoalsManager">
                            {{ participant?.managerEvaluation?.finalGoalsManagerEvaluationTranslated }}
                        </ng-container>
                        <ng-template #useFinalGoalsManager>
                            {{ participant?.managerEvaluation?.finalGoalsManagerEvaluation | translate }}
                        </ng-template>
                    </ion-col>
                    <ion-col *ngIf="principleCalculated">
                        {{ participant?.managerEvaluation?.finalPrinciplesManagerEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <!--                    <ion-col *ngIf="principleCalculated">-->
                    <!--                        {{ participant?.managerEvaluation?.finalPrinciplesManagerEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalPrinciplesManager">
                            {{ participant?.managerEvaluation?.finalPrinciplesManagerEvaluationTranslated | translate }}
                        </ng-container>
                        <ng-template #useFinalPrinciplesManager>
                            {{ participant?.managerEvaluation?.finalPrinciplesManagerEvaluation | translate }}
                        </ng-template>
                    </ion-col>
                    
                    <ion-col *ngIf="showLeadershipValues">
                        {{ ( participant?.managerEvaluation?.finalLeadershipManagerEvaluationTranslated | translate) || '--' }}
                    </ion-col>
                    <ion-col *ngIf="finalCalculated">
                        {{ participant?.selfEvaluation?.finalSelfEvaluationRelatedQuestionsUsed }}
                    </ion-col>
                    <!--                    <ion-col *ngIf="finalCalculated">-->
                    <!--                        {{ participant?.managerEvaluation?.finalSelfEvaluationFormula }}-->
                    <!--                    </ion-col>-->
                    <ion-col>
                        <ng-container *ngIf="useTranslationOnOverallEvaluation; else useFinalManager">
                            {{ participant?.managerEvaluation?.finalManagerEvaluationTranslated | translate }}
                        </ng-container>
                        <ng-template #useFinalManager>
                            {{ participant?.managerEvaluation?.finalManagerEvaluation | translate }}
                        </ng-template>
                    </ion-col>
                    <ion-col class="editGrade" colored *ngIf="canEditManagerEvaluation">
                        <ion-icon  class="bp-edit"
                                  (click)="confirmEditGrade()"
                        ></ion-icon>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-col>
    </ion-row>
</ion-grid>